import "./MoreInformation.css";

export const EarlyLeaver = (
  <div className="info-container small flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column ">
      <text className="sub-title">Early leaver</text>
      <text className="paragraph">
        An "early leaver" is a term used in founder vesting agreements to
        describe a founder who leaves the company prior to the end of the
        vesting period, or under circumstances that are not deemed to be
        acceptable or beneficial to the company.
      </text>
      <text className="paragraph">
        The reason why a distinction is made between good, early and bad leaver,
        is because, typically a different price is agreed upon for the shares. A
        good leaver is typically treated better than an early leaver and early
        leaver is typically treated better than a bad leaver.
      </text>
    </div>
  </div>
);
